import { Route, Routes } from "react-router";
import { Slide, ToastContainer } from "react-toastify";

import { DashBoardLayout } from "./components/DashBoards/DashBoardLayout";
import { EntitiesP } from "./components/Dataverse/Entities";
import { DataverseInstances } from "./components/Dataverse/Instances";
import { SourcesDataProvider } from "./components/Dataverse/SourcesDataProvider";
import { Layout } from "./components/Layout";
import { PlannerImportProgress } from "./components/MSPlanner/ImportProgress";
import { PlannerImportSuccess } from "./components/MSPlanner/ImportSuccess";
import { MSPlannerImport } from "./components/MSPlanner/MsplannerImport";
import { Steps } from "./components/Steps";
import { PATHS } from "./constants/PATHS";
import { Page404 } from "./pages/404";
import { AccountSettingsPage } from "./pages/AccountSettingsPage";
import { ConnectDataPage } from "./pages/ConnectDataPage";
import { DataversePage } from "./pages/DataversePage";
import { HistoryPage } from "./pages/HistoryPage";
import { MainPage } from "./pages/MainPage";
import { MSPlannerPage } from "./pages/MSPlannerPage";
import { PrivacyPolicyPage } from "./pages/PrivacyPolicyPage";
import { ProfileSettingsPage } from "./pages/ProfileSettingsPage";
import { ReportsPage } from "./pages/ReportsPage";
import { SettingsPage } from "./pages/SettingsPage";
import { PrivateRoute } from "./utils/privateRoute";

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<MainPage />} />
          <Route path={"/"} element={<Steps />}>
            <Route path={PATHS.LOAD_DATA_PATH} element={<ConnectDataPage />} />
          </Route>
          <Route element={<PrivateRoute />}>
            <Route path={PATHS.DATAVERSE} element={<DataversePage />}>
              <Route path={`${PATHS.DATAVERSE}/:destinationIdentifier`} element={<DataverseInstances />} >
                <Route path={":instanceIdentifier"} element={<EntitiesP />} >
                  <Route path={":entityIdentifier"} element={<SourcesDataProvider />} />
                </Route>
              </Route>
            </Route>
          </Route>
          <Route element={<PrivateRoute />}>
            <Route path={`${PATHS.MSPLANNER}/:instanceIdentifier?`} element={<MSPlannerPage />} >
              <Route path={":instanceIdentifier/:operationIdentifier"} element={<PlannerImportProgress />} />
              <Route path={":instanceIdentifier/:operationIdentifier/success"} element={<PlannerImportSuccess />} />
              <Route path={":instanceIdentifier?"} element={<MSPlannerImport />} />
            </Route>
          </Route>
          <Route element={<PrivateRoute />}>
            <Route
              path={PATHS.PROFILE_SETTINGS}
              element={<ProfileSettingsPage />}
            />
          </Route>
          <Route element={<PrivateRoute />}>
            <Route
              path={PATHS.ACCOUNT_SETTINGS}
              element={<AccountSettingsPage />}
            />
          </Route>
          <Route element={<PrivateRoute />}>
            <Route
              path={PATHS.SETTINGS}
              element={<SettingsPage />}
            />
          </Route>
          <Route element={<PrivateRoute />} path={PATHS.REPORTS_PATH}>
            <Route index element={<ReportsPage />} />
            <Route path={`:reportId/:syncLogId?`} element={<DashBoardLayout />} />
          </Route>
          <Route element={<PrivateRoute />}>
            <Route path={PATHS.HISTORY_PATH} element={<HistoryPage />} />
          </Route>
          <Route
            path={PATHS.PRIVACY_POLICY_PATH}
            element={<PrivacyPolicyPage />}
          />

          <Route path="*" element={<Page404 />} />
        </Route>
      </Routes>
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover
        theme="light"
        transition={Slide}
        style={{ zIndex: 9999 }}
      />
    </>
  );
}

export default App;
